import { ExportConfirmationConfig } from '../../models/Account'

export type ExportType = 'integration' | 'document'

export const getExportConfirmationEnabled = (exportType: ExportType, exportConfirmationConfig?: ExportConfirmationConfig): boolean => {
  if (!exportConfirmationConfig) {
    return false
  }

  const { integrationEnabled, documentEnabled } = exportConfirmationConfig

  if (exportType === 'integration') {
    return integrationEnabled
  }

  return documentEnabled
}
